export default __webpack_public_path__ + "static/media/FilterIconMarked.9f157576.svg";